import component from './index-new.vue'

export default component
